import LineProgress from './LineProgress';

export default LineProgress;
